import Navbar from "@/components/sipl/Navbar";
import Hero from "@/components/sipl/Hero";
import About from "@/components/sipl/About";
import Services from "@/components/sipl/Services";
import Projects from "@/components/sipl/Projects";
import Clients from "@/components/sipl/Clients";
import Leadership from "@/components/sipl/Leadership";
import WhyChoose from "@/components/sipl/WhyChoose";
import Certifications from "@/components/sipl/Certifications";
import TestimonialsBlog from "@/components/sipl/TestimonialsBlog";
import Contact from "@/components/sipl/Contact";
import Footer from "@/components/sipl/Footer";
import WhatsAppFAB from "@/components/sipl/WhatsAppFAB";

export default function Home() {
  return (
    <main className="bg-sipl-bg min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Projects />
      <Clients />
      <Leadership />
      <WhyChoose />
      <Certifications />
      <TestimonialsBlog />
      <Contact />
      <Footer />
      <WhatsAppFAB />
    </main>
  );
}
